<!-- Start Navbar Area -->
<div class="navbar-area">
    <div class="karlson-nav">
        <div class="container">
            <nav class="navbar navbar-expand-lg navbar-light">
                <a class="navbar-brand" itemprop="url" href="http://ewns.in" title="EWNS Web Services, create online presence for your business in less than 10 minutes" >
                    <img itemprop="logo" style="max-height: 160px;"  src="/assets/img/ewns-logo3.png" alt="ewns">
                </a>

                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                    <ul class="navbar-nav" >
                        <li class="nav-item">
                            <a itemprop="url" href="http://ewns.in" title="EWNS Web Services, create online presence for your business in less than 10 minutes" class="nav-link" >Home</a>

                        </li>

                        <li class="nav-item dropdown">
                            <a href="javascript:void(0)" class="nav-link dropdown-toggle" data-toggle="dropdown" >Pages <i class="fas fa-chevron-down"></i></a>

                            <ul class="dropdown-menu">
                                <li class="nav-item">
                                    <a href="http://ewns.in/about" itemprop="url" title="About us" routerLinkActive="active" class="nav-link" >About us</a>
                                </li>
                                <li class="nav-item">
                                    <a href="http://ewns.in/features" itemprop="url" title="Features we offer"  routerLinkActive="active" class="nav-link" >Features</a>
                                </li>

                                <li class="nav-item">
                                    <a href="http://ewns.in/team" itemprop="url" title="Our Team"  routerLinkActive="active" class="nav-link" >Team</a>
                                </li>

                                <li class="nav-item">
                                    <a href="http://ewns.in/faq" itemprop="url" title="Frequently Asked Questions"  routerLinkActive="active" class="nav-link" >FAQ</a>
                                </li>
                            </ul>
                        </li>

                        <li class="nav-item">
                            <a href="http://ewns.in/services" routerLinkActive="active" class="nav-link" itemprop="url" title="Our services" >Services</a>
                        </li>
   
                        <li class="nav-item">
                            <a href="http://ewns.in/pricing" itemprop="url" title="Pricing" routerLinkActive="active" class="nav-link" >Pricing</a>
                        </li>


                        <li class="nav-item">
                            <a href="http://ewns.in/partner" itemprop="url" title="Be a Partner" routerLinkActive="active" class="nav-link" >Partner</a>
                        </li>

                        <li class="nav-item">
                            <a href="http://ewns.in/customers/1" itemprop="url" title="Our customers" routerLinkActive="active" class="nav-link" >Customers</a>
                        </li>

                        
                        <li class="nav-item">
                            <a href="http://ewns.in/contact" itemprop="url" title="Contact us" routerLinkActive="active" class="nav-link" >Contact</a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</div>
<!-- End Navbar Area -->